import $ from "jquery";

class SubnavSticky {
	constructor(passedElement) {
		let self = this;

		self.elem = passedElement;
	}

	init() {
		let self = this;

		$(document).ready(function() {
			window.addEventListener('scroll', evt => {
				self.checkIfShouldFix();
			});
		});
	}

	checkIfShouldFix() {
		let self = this;

		if($(window).scrollTop() >= 450) {
			self.elem.classList.add('fixed');
		} else {
			self.elem.classList.remove('fixed');
		}
	}
}

export default SubnavSticky;